// import TitleScreen from "./TitleScreen"
import Game from "./Core/Game";
import Player from "./Player/Player";
import ServiceWorker from "./Web/ServiceWorker";


window.addEventListener('DOMContentLoaded', initGame());

if (Modernizr.gamepads) {
  console.log("Gamepads Supported!")
}


function removeExistingCanvas() {
  const els = document.body.children;
  if (els.length > 0) document.body.removeChild(els.item(0));
}


function initCanvas() {
  removeExistingCanvas();

  const canvas = document.createElement('canvas');
  // const gl = canvas.getContext('webgl');

  // const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
  // const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);

  // console.log(vendor);
  // console.log(renderer);

  canvas.id = "renderCanvas";

  document.body.appendChild(canvas);

  return canvas;
}


function initGame() {

  // Create canvas HTML element on which the browser will display the game...
  const canvas = initCanvas();

  // ...THEN init game!
  const game = window.game = new Game(canvas);



  // Improve onToggleFullscreen for something like 'bindEventListeners()' that will contain all the possible events.
  game.onToggleFullscreen();
  // game.listenForGamepads();
  game.render();


  window.addEventListener('resize', () => {
    game.onWindowResize();
  });
}

// @ts-ignore
if (module.hot) {
  // @ts-ignore
  module.hot.accept(function accept() {
    console.clear();
    console.log(' * * *  New Canvas!')


    initGame();

  })
}
